module.exports = __webpack_public_path__ + "img/mass-privilege-inactive@3x.png";